import { useState, useEffect } from "react"

function useBigScreen(maxWidth = 768) {
  const getIsBigScreen = () => {
    if (typeof window === "undefined") return true; // SSR fallback
    return !window.matchMedia(`(max-width: ${maxWidth}px)`).matches;
  };

  const [bigScreen, setBigScreen] = useState(getIsBigScreen);

  useEffect(() => {
    if (typeof window === "undefined") return; // 安全防护

    const resizeWatcher = () => {
      setBigScreen(getIsBigScreen());
    };

    window.addEventListener("resize", resizeWatcher);
    resizeWatcher(); // 初始化判断一次

    return () => {
      window.removeEventListener("resize", resizeWatcher);
    };
  }, [maxWidth]);

  return bigScreen
}

function useMedia(media: string) {
  const [match, setBigScreen] = useState(true)

  useEffect(() => {
    const resizeWatcher = () => {
      if (window.matchMedia(media).matches) {
        setBigScreen(false)
      } else {
        setBigScreen(true)
      }
    }
    window.addEventListener("resize", resizeWatcher)

    resizeWatcher()
    return () => {
      window.removeEventListener("resize", resizeWatcher)
    }
  }, [setBigScreen, media])

  return match
}

export { useMedia }

export default useBigScreen
